"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpDefinitionQueryFields = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const QueryFieldKey_1 = __importDefault(require("../QueryFieldKey"));
exports.OpDefinitionQueryFields = {
    [QueryFieldKey_1.default.OPDEFINITION_ENABLED]: {
        key: QueryFieldKey_1.default.OPDEFINITION_ENABLED,
        fieldType: BasicFieldType_1.default.BOOLEAN,
        label: () => lib_i18n_1.default.t('enabled'),
    },
    [QueryFieldKey_1.default.ORGTEMPLATE]: {
        key: QueryFieldKey_1.default.ORGTEMPLATE,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('template'),
    },
};
exports.default = exports.OpDefinitionQueryFields;
